<template>
    <nav div="navbar" :height="140">
        <div class="top">
            <div class="logo">
                <a :href="generateURL('/')">
                    <img
                        v-if="$root.theme === 'day'"
                        style="height: 50px"
                        :src="require(`@/assets/explorer_logo_dark.svg`)"
                    />
                    <img
                        v-else
                        style="height: 50px"
                        :src="require(`@/assets/explorer_logo.svg`)"
                    />
                    <h1>
                        <span class="hide">DComm Explorer</span>
                    </h1>
                </a>
            </div>
            <div class="links">
                <div class="routes">
                    <!-- <router-link to="/">Ecosystem</router-link> -->
                    <a :href="explorerURL">Explorer</a>
                    <a target="_blank" :href="walletURL">Wallet</a>
                    <!-- <a target="_blank" :href="faucetURL">Faucet</a> -->
                    <a target="_blank" href="https://dcomm.network"
                        >Community</a
                    >
                    <!-- <a :href="actChainURL">Home</a>
                    <router-link to="/subnets">Subnets</router-link>      
                    <a :href="tokensURL">Tokens</a>
                    <a :href="statusPageURL">Status</a>
                    <router-link to="/validators">Validators</router-link>
                    <a :href="tokensURL">Tokens</a>
                    <router-link to="/blockchains">Blockchains</router-link>
                    <a v-if="isMainnet" :href="statsURL">Stats</a>
                    <a :href="actChainURL">ACT-Chain</a>
                    <a :href="statusPageURL">Status</a>
                    <router-link to="/resources">Resources</router-link> -->
                    <DayNightToggle></DayNightToggle>
                </div>
            </div>
        </div>
        <div class="bottom mb-30">
            <!-- <div class="price_pair">
                    <span class="label">DCM</span>
                    <span class="value">{{ priceUSD }}</span>
                </div> -->
            <!-- <div class="price_pair">
                    <span class="label">Market Cap</span>
                    <span class="value">${{ marketCapUSD }}</span>
                </div> -->
            <div class="left routes">
                <a
                    :aria-selected="isRelatedRoute(0)"
                    class="tab_routes"
                    :href="generateURL('/')"
                    >Home</a
                >
                <a
                    :aria-selected="isRelatedRoute(1)"
                    class="tab_routes"
                    :href="generateURL('/action')"
                >
                    Action
                </a>
                <a
                    :aria-selected="isRelatedRoute(2)"
                    class="tab_routes"
                    :href="generateURL(astChainURL)"
                >
                    Asset
                </a>
                <a
                    :aria-selected="isRelatedRoute(3)"
                    class="tab_routes"
                    :href="generateURL(athChainURL)"
                    >Authority</a
                >
                <a
                    :aria-selected="isRelatedRoute(4)"
                    class="tab_routes"
                    :href="generateURL('/blockchain')"
                    >Blockchains</a
                >
                <!-- <router-link class="tab_routes" to="/subnets"
                    >Subnets</router-link
                > -->
            </div>

            <div class="right">
                <SearchBar
                    placeholder="Search for blocks, accounts, transactions..."
                    @search="onsearch"
                />
                <NetworkMenu />
            </div>
        </div>
    </nav>
</template>

<script>
import 'reflect-metadata'
import { Mixins, Component, Watch } from 'vue-property-decorator'
import SearchBar from '@/components/misc/SearchBar/SearchBar'
import NetworkMenu from './NetworkSettings/NetworkMenu.vue'
import {
    DEFAULT_NETWORK_ID,
    DEFAULT_NETWORK_NAME,
    DEFAULT_NETWORK,
    CURRENT_SUBNET,
} from '@/store/modules/network/network'
import { AuthorityGettersMixin } from '@/store/modules/authority/authority.mixins'
import { getMarketCapUSD } from '@/store/modules/authority/authority.getters'
import DayNightToggle from '@/components/misc/DayNightToggle.vue'

@Component({
    components: {
        SearchBar,
        NetworkMenu,
        DayNightToggle,
    },
})
export default class Navbar extends Mixins(AuthorityGettersMixin) {
    currencies = ['USD', 'DCM']
    netID = DEFAULT_NETWORK_ID.toString()
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    relatedRoutes = [
        {
            name: 'home',
            routes: [
                {
                    name: 'Home',
                    path: `/`,
                },
            ],
        },
        {
            name: 'action',
            routes: [
                {
                    name: 'Action Chain',
                    path: `/action`,
                },
                {
                    name: 'EVM Transaction',
                    path: `/evmtx/:id`,
                },
                {
                    name: 'EVM Transactions',
                    path: `/evmtx`,
                },
                {
                    name: 'EVM Block',
                    path: `/evmblock/:id`,
                },
                {
                    name: 'EVM Blocks',
                    path: `/evmblock`,
                },
                {
                    name: 'EVM Address',
                    path: `/evmaddress/:id`,
                },
                {
                    path: this.actChainURL,
                },
            ],
        },
        {
            name: 'asset',
            routes: [
                {
                    path: this.astChainURL,
                },
            ],
        },
        {
            name: 'authority',
            routes: [
                {
                    path: this.athChainURL,
                },
            ],
        },
        {
            name: 'blockchain',
            routes: [
                {
                    path: `/blockchain`,
                },
                {
                    path: `/blockchain/:id`,
                },
                {
                    name: 'Transactions',
                    path: `/tx`,
                },
                {
                    name: 'Transaction',
                    path: `/tx/:id`,
                },
                {
                    name: 'Address',
                    path: `/address/:id`,
                },
                {
                    query: { subnet: CURRENT_SUBNET },
                },
            ],
        },
    ]

    isRelatedRoute(index) {
        const { path, name, query } = this.currentPath
        const relatedRoute = this.relatedRoutes.at(index)

        let exist = false
        if (CURRENT_SUBNET !== null) {
            relatedRoute?.routes.map((route) => {
                if (route.query) {
                    if (
                        route.query.subnet.toLowerCase() ===
                        query.subnet.toLowerCase()
                    )
                        exist = true
                    else exist = false
                } else {
                    exist = false
                }
            })
        } else {
            relatedRoute?.routes.map((route) => {
                if (route.name) {
                    if (route.name === name) exist = true
                } else if (route.path === path) exist = true
            })
        }

        return exist
    }

    get themeType() {
        return this.$root.theme === 'night' ? 'dark' : 'light'
    }
    get theme() {
        return this.$vuetify.theme.themes[this.themeType]
    }
    get showSearch() {
        return this.$router.currentRoute.name === 'Home' ? false : true
    }
    get navColor() {
        return DEFAULT_NETWORK_ID === 1 ? '#FFF' : '#2196f3'
    }
    get logoColor() {
        return DEFAULT_NETWORK_ID === 1 ? 'black' : 'white'
    }
    get networkList() {
        return this.$store.state.networkList
    }
    get currentPath() {
        return this.$route
    }

    get selectedNet() {
        return this.$store.state.Network.selectedNetwork
    }

    @Watch('selectedNet')
    currentNetID() {
        if (this.selectedNet) this.netID = this.selectedNet.networkId
        else this.netID = DEFAULT_NETWORK_ID.toString()
    }

    get _actChainID() {
        return DEFAULT_NETWORK.actChainId
    }

    get _astChainID() {
        return DEFAULT_NETWORK.astChainId
    }

    get _athChainID() {
        return DEFAULT_NETWORK.athChainId
    }

    get actChainURL() {
        return `/blockchain/${this._actChainID}`
    }

    get astChainURL() {
        return `/blockchain/${this._astChainID}`
    }

    get athChainURL() {
        return `/blockchain/${this._athChainID}`
    }

    get statsURL() {
        return 'https://stats.dcm.network/' //@LINK_TO_CHANGE
    }

    get pricesLoaded() {
        return this.$store.state.pricesLoaded
    }

    get priceUSD() {
        const prices = this.$store.state.prices
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        })
        return prices ? formatter.format(prices.usd) : '$-.--'
    }

    get marketCapUSD() {
        return getMarketCapUSD()
    }

    get statusPageURL() {
        return DEFAULT_NETWORK.statusUrl
    }

    get explorerURL() {
        return DEFAULT_NETWORK.actChainExplorerUrl
    }

    get walletURL() {
        return DEFAULT_NETWORK.walletUrl
    }

    get faucetURL() {
        return DEFAULT_NETWORK.dcommFaucetUrl
    }

    generateURL(path) {
        const baseUrl = path
        const queryParams = { network: DEFAULT_NETWORK_NAME }

        const url = new URL(baseUrl, window.location.origin)
        Object.keys(queryParams).forEach((key) => {
            url.searchParams.append(key, queryParams[key])
        })

        return url.toString()
    }

    onsearch(val, selectedChain, selectedFilter) {
        if (selectedChain !== 'ACT') {
            this.$router
                .push({
                    path: '/search',
                    query: { query: val, chain: selectedChain },
                })
                .catch((error) => {
                    if (error.name != 'NavigationDuplicated') {
                        throw error
                    }
                })
        } else {
            let filter
            switch (selectedFilter) {
                case 'Transaction Hash':
                    filter = 'tx'
                    break
                case 'Block Hash':
                    filter = 'hash'
                    break
                case 'Block Height':
                    filter = 'height'
                    break
                case 'Address':
                    filter = 'key'
                    break
            }
            this.$router
                .push({
                    path: '/search',
                    query: {
                        query: val,
                        filter: filter,
                        chain: selectedChain,
                    },
                })
                .catch((error) => {
                    if (error.name != 'NavigationDuplicated') {
                        throw error
                    }
                })
        }
    }
}
</script>

<style scoped lang="scss">
.navbar {
    z-index: 10 !important;
    display: flex !important;
    flex-direction: column !important;
    background-color: transparent !important;
}

.top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.logo {
    display: flex;
    flex-direction: row;
    padding: 12px 0;
    white-space: nowrap;
    box-sizing: border-box;

    a {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: 100%;
        color: var(--font) !important;
        text-decoration: none !important;
    }

    h1 {
        padding-left: 20px;
        margin: 0;

        &:hover {
            opacity: 0.7;
            text-decoration: none !important;
        }

        .hide {
            font-size: 0;
            width: 1px;
            height: 1px;
            display: inline-block;
            overflow: hidden;
            position: absolute !important;
            border: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            clip: rect(1px, 1px, 1px, 1px);
        }

        .subnet {
            font-size: 12px;
            color: $primary-color;
            padding-bottom: 7px;
            display: inline-block;
        }
    }
}

.network_menu {
    margin-left: 20px !important;
    @media screen and (min-width: 960px) and (max-width: 1280px) {
        margin-left: 0px !important;
    }
}

.bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: var(--bg-explorer);
    backdrop-filter: blur(25px);
    color: var(--font) !important;

    .routes {
        .tab_routes {
            color: var(--font) !important;

            &:hover {
                color: $CLR03 !important;
            }

            &[aria-selected='true'] {
                color: $CLR03 !important;
            }
        }
    }

    .right {
        display: flex;
    }
}
.mb-30 {
    margin-bottom: 30px !important;
}

.search_bar {
    min-width: 360px;
    width: 100%;
}

.links {
    font-weight: 700;
    font-size: 15px;
    line-height: 130%;
    letter-spacing: -0.018em;
    opacity: 0.5;
    justify-content: space-between;

    > div {
        justify-content: center;
        margin: 8px 0px;
        white-space: nowrap;
        flex-wrap: nowrap;
    }
}
.routes {
    display: inline-flex;
    overflow: auto;
    padding: 4px 0px;
    white-space: normal;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: -0.018em;
}

.routes a {
    font-size: 15px;
    color: var(--font) !important;
    padding-right: 30px;

    & .router-link-active {
        color: $primary-color !important;
        font-weight: 700;
    }

    &:hover {
        opacity: 0.7;
        text-decoration: none;
    }

    &:last-child {
        padding-right: 0;
    }
}

@include lgOrBigger {
    .top,
    .bottom {
        padding: $container_padding_xl !important;
    }
}

@include lgOnly {
    .top,
    .bottom {
        padding: $container_padding_lg !important;
    }
}

@include mdOnly {
    .top,
    .bottom {
        padding: $container_padding_md !important;
    }
}

@include smOrBigger {
    .top {
        .links {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}

@include smOnly {
    .logo {
        height: 100%;
        padding: 15px 0px 15px 6px;
        display: flex;
        flex-direction: column;

        a {
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            height: 100%;
        }

        h1 {
            padding-left: 161px;
            height: 12px;
            .subnet {
                font-size: 12px;
                color: $primary-color;
                padding-top: 9px;
                padding-bottom: 0;
                display: block;
            }
        }

        img {
            max-height: calc(100% - 15px);
        }
    }

    .links {
        width: 100%;
        overflow: auto;
    }

    .spacer_mid {
        display: none;
    }
}
</style>

<style lang="scss">
#navbar {
    .v-toolbar--dense .v-toolbar__content,
    .v-toolbar--dense .v-toolbar__extension {
        padding-top: 0;
        padding-bottom: 0;
        padding-right: 0;
        padding-left: 0;
    }
}
</style>
